import { useQueryParams } from './use-query-params'
import {
  CONTINUE_URL_QUERY_PARAM,
  REAUTHENTICATE_QUERY_PARAM,
  SECURITY_QUERY_PARAM,
  DELETE_ACCOUNT_QUERY_PARAM,
} from 'config/constants'

const isUrlParamTrue = (url: string, param: string) => {
  try {
    return new URL(url).searchParams.get(param) === 'true'
  } catch {
    return false
  }
}

export const useAuthParams = () => {
  const getParam = useQueryParams()

  const continueUrl = getParam(CONTINUE_URL_QUERY_PARAM)

  const isParamTrue = (param: string) =>
    isUrlParamTrue(continueUrl, param) || getParam(param) === 'true'

  return {
    security: isParamTrue(SECURITY_QUERY_PARAM),
    deleteAccount: isParamTrue(DELETE_ACCOUNT_QUERY_PARAM),
    reauthenticate: isParamTrue(REAUTHENTICATE_QUERY_PARAM),
    continueUrl,
  }
}
